module.exports = __webpack_public_path__ + "media/my_images/vision/2x/text-b8ae99517484fc68fc50bfa94baba3d4.png";